import { RecordsTable, TableWithHeader } from 'dyl-components'
import React, { useEffect, useState } from 'react'
import { Header } from 'semantic-ui-react'
import HistoryHeader from './subcomponents/Header'
import HistoryRow from './subcomponents/Row'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import "./index.scss"
import historyActions from 'actions/history';
import { destinationCategoriesOptions } from 'shared/RouteSection/subcomponents/constants'

export default function History() {
    const LIMIT = 25;
    const [params] = useSearchParams();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { history: histories = [], isReadingHistory = false, count:historyCount = 0 } = useSelector(state => state?.history || {});
    const { contact_id, account_id } = useParams();
    const HISTORY_URL = `/${contact_id ? "contact" : "account"}/${contact_id ? contact_id : account_id}/history`;
    const [filters, setFilters] = useState({
        activity_type: params.get('activity_type')?.split(',')
    })
    const { destinations } =
        useSelector((state) => {
            return {
                destinations: state.pbx_config.destinations || {},

            };
        });
    const destinationCategories = destinationCategoriesOptions.map((category) => {
        const options = destinations[category.value]?.map((destination) => ({
            key: destination.destination_id,
            value: destination.fs_destination,
            text: destination.label,
        })) || [];
        return ({
            ...category,
            options: options,
            disabled: options.length === 0
        });
    });
    const onPageChange = (_, { activePage }) => {
        const query = new URLSearchParams(params);
        query.set('page', activePage);
        const query_string = query.toString();
        navigate(`${HISTORY_URL}${query_string ? `?${query_string}` : ''}`);
    };

    const onFilter = async (_, { name, value }) => {
        setFilters({
            ...filters,
            [name]: value
        });
    }

    useEffect(() => {
        const { activity_type, ...otherParams } = Object.fromEntries(params);
        const activityTypes = activity_type?.split(",") || [];
        const queryParameters = {
            ...otherParams,
            limit: LIMIT,
            activity_type: activity_type ? [
                ...activityTypes.filter(type => type !== "record"),
                ...(!activityTypes.includes("record") ? [] : ["contact", "account", "master_account"])
            ] : null
        }

        dispatch(historyActions.readHistory(contact_id || account_id, queryParameters));

    }, [params, dispatch, account_id, contact_id]);
    useEffect(() => {
        const query = new URLSearchParams(params);
        const { activity_type } = filters;
        if (activity_type?.length > 0) {
            query.set('activity_type', activity_type.join(','));
        } else {
            query.delete('activity_type');
        }
        const query_string = query.toString();
        navigate(`${HISTORY_URL}${query_string ? `?${query_string}` : ''}`);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters])
    return (
        <div className='HistoryTable'>
            <TableWithHeader
                header={
                    <Header as='h2'>History</Header>
                }
                table={
                    <RecordsTable
                        tableBodyClassName="UploadsTable"
                        isTableLoading={isReadingHistory}
                        isTableEmpty={!historyCount}
                        TableHeader={<HistoryHeader onFilter={onFilter} />}
                        TableRows={histories?.map((history) => (
                            <HistoryRow historyData={history} destinationCategories={destinationCategories} />
                        ))}
                        recordsCount={historyCount}
                        recordsName="History"
                        emptySubtitle=" "
                        activePage={params.get('page')}
                        emptyListTitle={"No Histories Available"}
                        onPageChange={onPageChange}
                        recordsLimit={LIMIT}
                    />
                }
            />
        </div>
    )
}
